module.exports = __webpack_public_path__ + "static/media/29ADMSPC30.aa9c2606.jpg";